import { Flex, Image, Link, Text } from "@chakra-ui/react";
import React, { memo } from "react";

export default memo(function SupportCardComponent({ item }) {
   function showLinkComponent(linkUrl) {
      return (
         <Link
            href={linkUrl}
            w={"full"}
            userSelect="none"
            isExternal
            fontSize={14}
            color="blue.500"
            fontFamily={'Arial-BoldMT'}
            h={"32px"}
            mt={"12px"}
            textAlign="center"
            lineHeight={"32px"}
            bg={"white"}
            _hover={{color:{base:"blue.500",BREAK_LPC:'blue.600'}}}
            borderRadius={"16px"}
            border={"1px solid #E6E6E6"}>
            Explore what’s happening on Twitter
         </Link>
      );
   }
   return (
      <Flex flexDir={'column'} whiteSpace={'nowrap'} 
         flexShrink={'0'}>
         <Link
            href={item.twitter_url}
            isExternal
            mt={"30px"}
            textAlign="center">
            <Flex alignItems={"center"} >
               <Image
                  alt={item.title}
                  userSelect="none"
                  className="refImg"
                  src={undefined}
                  boxSize={'44px'}
                  borderRadius="full"
                  data-src={process.env.REACT_APP_PUBLIC_URL + item.icon}
               />
               <Text ml={"15px"} variant={'16_black_bold'}>
                  {item.title}
               </Text>
            </Flex>
         </Link>
         <Image
            alt={item.title}
            userSelect="none"
            className="refImg"
            src={undefined}
            boxSize={{base:'72vw',BREAK_PAD:'340px',BREAK_LPC:'258px',BREAK_PC:'365px'}} 
            mt={"12px"}
            borderRadius={'8px'}
            fallbackSrc={process.env.REACT_APP_PUBLIC_URL+item.pic}
            data-src={process.env.REACT_APP_PUBLIC_URL + item.pic}
         />
         {showLinkComponent(item.twitter_url)}
      </Flex>
   );
});
